module.exports = __webpack_public_path__ + "static/media/the_invisible_women_farmers_tablet.1be73f05.jpg";